export default __webpack_public_path__ + "static/media/db_red.86e46e4d.svg";